<div class="w-full max-w-6xl mx-auto p-10 bg-primary-dark rounded-lg text-white">
  <!-- Título -->
  <div class="mb-6 border-b border-white/10 pb-3">
    <h2 class="text-2xl font-bold tracking-tight">Cadastrar Newsletter</h2>
  </div>

  <form [formGroup]="form" (ngSubmit)="salvar()" enctype="multipart/form-data" class="space-y-7">

    <mat-form-field appearance="fill" class="w-full">
      <mat-label>Título</mat-label>
      <input matInput formControlName="titulo" />
    </mat-form-field>

    <mat-form-field appearance="fill" class="w-full">
      <mat-label>Texto</mat-label>
      <textarea matInput rows="12" formControlName="texto"></textarea>
    </mat-form-field>

    <mat-form-field appearance="fill" class="w-full">
      <mat-label>Tópico</mat-label>
      <mat-select formControlName="topicoId">
        <mat-option *ngFor="let t of topicos" [value]="t.id">#{{ t.nome }}</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Upload da Imagem -->
    <div class="flex flex-col gap-2">
      <label class="text-sm font-medium">Imagem da Newsletter</label>
      <input type="file" accept="image/*" (change)="onFileSelected($event)" class="rounded pr-2 text-white" />
      <img *ngIf="imagemPreview" [src]="imagemPreview" alt="Prévia da Imagem"
           class="w-full max-h-96 object-contain rounded border border-gray-600 mt-2" />
    </div>

    <mat-form-field appearance="fill" class="w-full">
      <mat-label>Fonte da Imagem</mat-label>
      <input matInput formControlName="fonteImagem" />
    </mat-form-field>

    <mat-form-field appearance="fill" class="w-full">
      <mat-label>Autor</mat-label>
      <input matInput formControlName="autor" />
    </mat-form-field>

    <div class="flex justify-end gap-3 mt-6">
      <button mat-stroked-button type="button" (click)="cancelar()">Cancelar</button>
      <button mat-flat-button color="primary" [disabled]="form.invalid || !selectedFile" type="submit">Salvar</button>
    </div>
  </form>
</div>
